import { ThemeConfig, ThemeName } from '../types/theme';

export const THEME_CONFIGS: Record<ThemeName, ThemeConfig> = {
  // LIGHT THEMES
  'sage-study': {
    name: 'sage-study',
    mode: 'light',
    colors: {
      background: '#F5F7F4',
      surface: '#FFFFFF',
      sidebar: '#E8EDE6',
      primary: '#5B8A72',
      text: '#2D3E2F',
      border: '#D5DFD3',
      header: '#FFFFFF',
    },
  },
  'warm-linen': {
    name: 'warm-linen',
    mode: 'light',
    colors: {
      background: '#F9F6F1',
      surface: '#FFFFFF',
      sidebar: '#F0EBE3',
      primary: '#D4834F',
      text: '#2C2416',
      border: '#E0D5C7',
      header: '#FFFFFF',
    },
  },
  'fresh-editorial': {
    name: 'fresh-editorial',
    mode: 'light',
    colors: {
      background: '#FAFBFC',
      surface: '#FFFFFF',
      sidebar: '#F4F6F8',
      primary: '#0066FF',
      text: '#1A1A1A',
      border: '#E1E4E8',
      header: '#FFFFFF',
    },
  },

  'legacy': {
    name: 'legacy',
    mode: 'light',
    colors: {
      background: '#eee',
      surface: '#FFFFFF',
      sidebar: '#ccc',
      primary: '#6c757d',
      text: '#1A1A1A',
      border: '#E1E4E8',
      header: '#FFFFFF',
    },
  },

  // DARK THEMES
  'deep-midnight': {
    name: 'deep-midnight',
    mode: 'dark',
    colors: {
      background: '#0F1419',
      surface: '#1A1F2E',
      sidebar: '#141820',
      primary: '#00D4FF',
      text: '#E8ECF1',
      border: '#252E40',
      header: '#1A1F2E',
    },
  },
  'warm-charcoal': {
    name: 'warm-charcoal',
    mode: 'dark',
    colors: {
      background: '#1A1511',
      surface: '#261F1A',
      sidebar: '#1E1816',
      primary: '#FF9F45',
      text: '#E8DED6',
      border: '#2F2925',
      header: '#261F1A',
    },
  },
  'elegant-noir': {
    name: 'elegant-noir',
    mode: 'dark',
    colors: {
      background: '#050505',
      surface: '#0F0F0F',
      sidebar: '#0A0A0A',
      primary: '#A855F7',
      text: '#F5F5F5',
      border: '#1F1F1F',
      header: '#0F0F0F',
    },
  },
  'purple-black': {
    name: 'purple-black',
    mode: 'dark',
    colors: {
      background: '#131327',
      surface: '#212143',
      sidebar: '#0A0A0A',
      primary: '#38D102', // verde: 38D102 , amarillo: FAD000 , Cyan: 9EFFFF (text1) - pistache: A5FF90 (text2), text3: A599E9
      text: '#FAD000',
      border: '#212143',
      header: '#131327',
    },
  },
};

export const LIGHT_THEMES: ThemeName[] = ['sage-study', 'warm-linen', 'fresh-editorial','legacy'];
export const DARK_THEMES: ThemeName[] = ['deep-midnight', 'warm-charcoal', 'elegant-noir','purple-black'];
export const ALL_THEMES: ThemeName[] = [...LIGHT_THEMES, ...DARK_THEMES];

export const THEME_LABELS: Record<ThemeName, string> = {
  'sage-study': 'Sage Study',
  'warm-linen': 'Warm Linen',
  'fresh-editorial': 'Fresh Editorial',
  'deep-midnight': 'Deep Midnight',
  'warm-charcoal': 'Warm Charcoal',
  'elegant-noir': 'Elegant Noir',
  'legacy':'Legacy',
  'purple-black':'Deep Purple'
};
